module.exports = __webpack_public_path__ + "static/media/supplies_delivered.98c01b12.jpg";